import { render, staticRenderFns } from "./housedetail.vue?vue&type=template&id=20b05d86&scoped=true&"
import script from "./housedetail.vue?vue&type=script&lang=js&"
export * from "./housedetail.vue?vue&type=script&lang=js&"
import style0 from "./housedetail.vue?vue&type=style&index=0&id=20b05d86&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b05d86",
  null
  
)

component.options.__file = "housedetail.vue"
export default component.exports